'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var web = require('solid-js/web');

const _tmpl$ = ["<svg", " fill=\"currentColor\" stroke-width=\"0\" style=\"", "\" ", " xmlns=\"http://www.w3.org/2000/svg\">", "", "</svg>"],
      _tmpl$2 = ["<title>", "</title>"];
function IconTemplate(iconSrc, props) {
  const mergedProps = web.mergeProps(iconSrc.a, props);
  return web.ssr(_tmpl$, web.ssrAttribute("stroke", web.escape(iconSrc.a.stroke, true), false), web.ssrStyle({ ...props.style,
    overflow: "visible",
    color: props.color || "currentColor"
  }), web.ssrSpread(mergedProps, true, true) + web.ssrAttribute("height", web.escape(props.size, true) || "1em", false) + web.ssrAttribute("width", web.escape(props.size, true) || "1em", false), web.isServer && iconSrc.c, props.title && web.ssr(_tmpl$2, web.escape(props.title)));
}

exports.IconTemplate = IconTemplate;
